"use strict";
exports.__esModule = true;
exports.PopupPosition = void 0;
var PopupPosition;
(function (PopupPosition) {
    PopupPosition["TopLeft"] = "topLeft";
    PopupPosition["TopRight"] = "topRight";
    PopupPosition["LeftTop"] = "leftTop";
    PopupPosition["LeftBottom"] = "leftBottom";
    PopupPosition["BottomLeft"] = "bottomLeft";
    PopupPosition["BottomRight"] = "bottomRight";
    PopupPosition["RightTop"] = "rightTop";
    PopupPosition["RightBottom"] = "rightBottom";
})(PopupPosition = exports.PopupPosition || (exports.PopupPosition = {}));
